import { render, staticRenderFns } from "./BoardGamesCategory.vue?vue&type=template&id=54ad6ac2&"
import script from "./BoardGamesCategory.vue?vue&type=script&lang=js&"
export * from "./BoardGamesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports